import React from "react";
import { Box, Container, Paper, Typography, Alert } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";

const StatusPage: React.FC = () => {
  const { user } = useAuth();

  if (!user?.status) {
    return null;
  }

  const isPending = user.status === "pending";
  const isRejected = user.status === "rejected";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "background.default",
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ padding: 4 }}>
          {isRejected && (
            <>
              <Alert severity="error" sx={{ mb: 2 }}>
                Request has been rejected by admin.
              </Alert>
              <Typography variant="body1" align="center" color="text.secondary">
                Your access request has been rejected. Please contact the
                administrator for more information.
              </Typography>
            </>
          )}

          {isPending && (
            <>
              <Alert severity="info" sx={{ mb: 2 }}>
                Waiting for approval.
              </Alert>
              <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 2 }}>
                An administrator will review your request. You will be notified
                once your access is approved.
              </Typography>
              {user.requestedRole && (
                <Typography variant="body2" align="center" color="text.secondary">
                  Requested Role: <strong>{user.requestedRole}</strong>
                </Typography>
              )}
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default StatusPage;

